// GovernorHub, The Key and Robin now share one set of customer facing legal
// documents, published on the company site rather than in each help centre.
const COMPANY_SITE_URL = 'https://thekeysupport.com';

// The AI Features service specific terms are a section of the Customer
// agreement rather than a document of their own, hence the anchor.
export const LEGAL_DOCUMENT_URLS = {
  privacyStatement: `${COMPANY_SITE_URL}/documents/privacy-statement/`,
  aiFeaturesTerms: `${COMPANY_SITE_URL}/documents/customer-agreement/#service-specific-terms-ai-features`,
};
